// HTTP/WebSocket and service-worker delivery can report the same message.
// Retain one bounded account-scoped set and never alert over a visible chat.
export function createChatNoticeGate({ maxEntries = 500, ttlMs = 120000 } = {}) {
  const seen = new Map();
  return {
    clear() { seen.clear(); },
    accept(notice, { activeChatId = null, visible = true, focused = true, now = Date.now() } = {}) {
      for (const [key, at] of seen) if (now - at > ttlMs) seen.delete(key);
      const chatId = notice?.chat_id;
      const messageId = notice?.message_id;
      const reaction = notice?.kind === 'reaction' || notice?.type === 'reaction';
      const key = chatId != null && messageId != null
        ? `${reaction ? 'reaction' : 'message'}:${chatId}:${messageId}${reaction ? `:${notice?.emoji || notice?.content || ''}` : ''}`
        : null;
      if (key && seen.has(key)) return false;
      if (key) {
        seen.set(key, now);
        while (seen.size > maxEntries) seen.delete(seen.keys().next().value);
      }
      return Boolean(visible && focused && !(activeChatId != null && String(activeChatId) === String(chatId)));
    },
  };
}

export function openChatId(location, modal) {
  if (modal?.open && modal.chatId != null) return modal.chatId;
  if (!/^\/chats\/?$/.test(location?.pathname || '')) return null;
  return new URLSearchParams(location.search || '').get('chatId');
}
